import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';

import { AbsenceType } from '~/data/absences/types';
import { fetchEmployeeDetails } from '~/data/employeeProfile';
import { useAuthentication } from '~/data/user/useAuthentication';
import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { LibraryComponentProviders } from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { AbsencesTable } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { AppDispatch } from '~/store';

export type AbsencesTabContent_OnUpdateLegacy = {
  onUpdateLegacy?: (updateReferences: string[]) => void;
};

export type AbsencesTabContentProps = AbsencesTabContent_OnUpdateLegacy & {
  employeeId: number;
  absenceType: AbsenceType;
};

export const AbsencesTabContent = (props: AbsencesTabContentProps) => {
  const { employeeId } = props;
  const { userDetails, isAuthenticated } = useAuthentication();

  const {
    requiredStatus: { isInitializing },
  } = useInitializeCommonReduxData({
    required: [
      DispatchReduxFetch.ApplicationConfig,
      DispatchReduxFetch.CompanyData,
      DispatchReduxFetch.AllEnums,
      DispatchReduxFetch.Languages,
      DispatchReduxFetch.AllEmployees,
      DispatchReduxFetch.AllOrgUnits,
    ],
  });

  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    if (isAuthenticated && !!userDetails) {
      dispatch(fetchEmployeeDetails(`${employeeId}`));
    }
  }, [dispatch, isAuthenticated, userDetails, employeeId]);

  if (isInitializing || !isAuthenticated) {
    return <LoadingView />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <AbsencesTable {...props} />
    </LibraryComponentProviders>
  );
};

export const renderAbsencesTabContent = (
  containerId: string,
  props: AbsencesTabContentProps,
) => {
  ReactDOM.render(
    <Providers>
      <AbsencesTabContent {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
